/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerCompanyUpdateLegalNoticesRequest
 */
export interface FreelancerCompanyUpdateLegalNoticesRequest {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FreelancerCompanyUpdateLegalNoticesRequest
     */
    legalNotices: { [key: string]: string; };
}

/**
 * Check if a given object implements the FreelancerCompanyUpdateLegalNoticesRequest interface.
 */
export function instanceOfFreelancerCompanyUpdateLegalNoticesRequest(value: object): value is FreelancerCompanyUpdateLegalNoticesRequest {
    if (!('legalNotices' in value) || value['legalNotices'] === undefined) return false;
    return true;
}

export function FreelancerCompanyUpdateLegalNoticesRequestFromJSON(json: any): FreelancerCompanyUpdateLegalNoticesRequest {
    return FreelancerCompanyUpdateLegalNoticesRequestFromJSONTyped(json, false);
}

export function FreelancerCompanyUpdateLegalNoticesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerCompanyUpdateLegalNoticesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'legalNotices': json['legalNotices'],
    };
}

export function FreelancerCompanyUpdateLegalNoticesRequestToJSON(value?: FreelancerCompanyUpdateLegalNoticesRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'legalNotices': value['legalNotices'],
    };
}

